module.exports = __webpack_public_path__ + "static/media/7-Suarez.91565e28.png";